import { styled } from '@mui/material/styles';
import IconButton from '@mui/material/IconButton';

const AnimatedIconButton = styled(IconButton)(({ theme }) => ({
  transition: 'transform 0.2s ease-in-out',
  '&:active': {
    transform: 'scale(0.9)',
  },
}));

export default AnimatedIconButton;